<template>
    <div
        :class="[
            'flex flex-1 flex-col border-r bg-primary-500 relative dark:bg-darkblue rounded-tr-[50px]',
            (isSidebarExpanded) ? !isMobile ? 'min-w-[350px]' : '' : 'max-w-[144px]'
        ]"
        @mouseenter="hover = true"
        @mouseleave="hover = false"
    >

        <div class="h-0 flex-1 overflow-y-auto pb-3 pt-4 xl:pl-1">
            <div class="flex flex-shrink-0 items-center px-4 mt-4" v-if=" isSidebarExpanded">
                <LogoSideBar />
            </div>

            <div class="flex flex-shrink-0 items-center px-8 mt-2" v-else>
                <LogoCollapsedSidebar />
            </div>

            <SidebarContentClient :user="user" :isCollapsed="isCollapsed" class="px-4" v-if="isClient" />
            <SidebarContent :user="user" :isCollapsed="isCollapsed" class="px-4" v-else />
        </div>



    </div>
</template>

<script setup lang="ts">
import {computed, defineProps, onMounted, onUnmounted, ref} from "vue";
import { Avatar } from 'craftable-pro/Components';
import Logo from "@/craftable-pro/Components/Logo.vue";
import SidebarContent from "./Sidebar/SidebarContent.vue";
import { useUser } from "@/hooks/useUser";
import {ArrowLeftIcon} from "@heroicons/vue/20/solid";
import {ArrowRightIcon} from "@heroicons/vue/24/outline";

const { user } = useUser();
const emit = defineEmits(['sidebarToggle']);
const sidebarExpanded = ref(true);

const toggleSidebar = () => {
    sidebarExpanded.value = !sidebarExpanded.value;
    emit('sidebarToggle', sidebarExpanded.value);
};

import AOS from 'aos';
import 'aos/dist/aos.css';
import IconButton from "@/craftable-pro/Components/Button/IconButton.vue";
import ThemeToggle from "@/craftable-pro/Components/Theme/ThemeToggle.vue";
import UserDropdown from "@/craftable-pro/Components/UserDropdown.vue";
import LogoSideBar from "@/craftable-pro/Components/LogoSideBar.vue";
import {useClient} from "@/hooks/useClient";
import SidebarContentClient from "@/craftable-pro/Components/Sidebar/SidebarContentClient.vue";
import {usePage} from "@inertiajs/vue3";
import LogoCollapsedSidebar from "@/craftable-pro/Components/LogoCollapsedSidebar.vue";
import {useOnboarding} from "@/Composables/useOnboarding";

AOS.init({
    duration: 400,
    easing: 'linear',
    once: false,
});

interface Props {
    isDesktop?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    isDesktop: false,
});

const { isClient } = useClient();

const isDashboard = computed(() => {
    const url = usePage().url.split("?")[0];

    return url.indexOf('/dashboard') !== -1;
});

const hover = ref(false);

const isHover = computed(() => hover.value);
const isCollapsed = computed(() => !isSidebarExpanded.value);

const windowWidth = ref(window.innerWidth)

const handleResize = () => {
  windowWidth.value = window.innerWidth
}

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
});

onMounted(() => {
  window.addEventListener('resize', handleResize)
});

const isMobile = computed<boolean>(() => {
  return windowWidth.value < 768;
})

const { isTourActive, currentStep } = useOnboarding();

const isSidebarExpanded = computed(() => {
    const tourIsActiveOnSidebar = isTourActive.value && currentStep.value?.component === 'SidebarContentClient';
    return hover.value || tourIsActiveOnSidebar || isMobile.value;
});
</script>

<style scoped>
.-right-10 {
    right: -10px;
}
</style>

